

  
const content = `# Single Sign-On Integration

If your organization uses an Identity and Access Management (IAM) system for user authentication and authorization, we strongly recommend you to integrate 
the OnData Platform with your IAM system for Single Sign-On (SSO) purpose. The OnData Platform supports both the SAML 2.0 protocol and the OpenID Connect (OIDC) 
protocol, and can be easily integrated with most popular IAM systems, such as Microsoft Entra ID, Okta, SailPoint, and ForgeRock.  
  
With SSO integration, OnData allows you to manage not only the assignment of OnData Application Roles to your users and user groups, but also the assignment of 
Data Access Roles. You can enforce consistent access control to your sensitive data, no matter where it is stored or copied. Detailed audit logs are available 
to track who has accessed what data where and when.  
  
Below are a few sample SSO integration scenarios with Microsoft Entra ID and Okta. You can follow similar procedures to integrate the OnData Platform with other 
types of IAM systems.  
* [**Microsoft Entra ID Integration Using OIDC**](reference_doc#ondata_portal/sso_integration/entraid_integration_using_oidc)
* [**Microsoft Entra ID Integration Using SAML 2.0**](reference_doc#ondata_portal/sso_integration/entraid_integration_using_saml)
* [**Okta Integration Using OIDC**](reference_doc#ondata_portal/sso_integration/okta_integration_using_oidc)
* [**Okta Integration Using SAML 2.0**](reference_doc#ondata_portal/sso_integration/okta_integration_using_saml)

After SSO integration is configured, you can further assign OnData Application Roles and Data Access Roles to your users and user groups in your IAM system. 
Below samples provide configuration details for role assignment in Microsoft Entra ID and Okta. You can follow similar procedures to assign OnData Application 
Roles and Data Access Roles in other types of IAM systems.  
* [**Assigning Roles in Microsoft Entra ID**](reference_doc#ondata_portal/sso_integration/entraid_role_assignment)
* [**Assigning Roles in Okta**](reference_doc#ondata_portal/sso_integration/okta_role_assignment)
  
If your organization uses Microsoft Office 365, most likely you can integrate the OnData Platform with Microsoft Entra ID to enable SSO. Please note that the 
OnData SecureFile file sharing feature leveraging Digital Rights Management (DRM) technology is only supported when you configure SSO integration with Microsoft 
Entra ID using the OIDC protocol. Please choose the OIDC option if you would like to have that feature enabled later on.  
  
`
  
export default content;
